export const TemplateDownloadModalId: string = 'TemplateDownloadModalId';
